<app-menu>
  <h1>The Warehouse Data Centre</h1>
  <p>
    Welcome to the one-stop shop for all your warehouse data needs, in file format!
  </p>

  <main>
    <!-- Internal CSV -->
    <div class="csv-div">
      <h2>Customer Spot Count for Internal Use</h2>
      <button mat-raised-button color="primary" (click)="createInternalCSV()">
        Create Internal CSV
      </button>
    </div>

    <!-- Customer-Specific CSV -->
    <div class="csv-div">
      <h2>Customer-Specific Warehouse Spots</h2>

      <!-- Wrap everything in a form so formControlName has a parent -->
      <form [formGroup]="reportForm" class="customer-form">
        <mat-form-field appearance="fill" class="customer-select">
          <mat-label>Select Customer</mat-label>
          <mat-select
            formControlName="customerUuid"
            disableOptionCentering
            panelClass="select-panel">

            <!-- Search input (required to live inside a mat-option) -->
            <mat-option>
              <ngx-mat-select-search
                [formControl]="customerSearchCtrl"
                placeholderLabel="Search customers..."
                noEntriesFoundLabel="No matching customers">
              </ngx-mat-select-search>
            </mat-option>

            <!-- Customer options -->
            <mat-option
              *ngFor="let c of filteredCustomers"
              [value]="c.inventory_warehouse_customer_contact_uuid">
              {{ c.inventory_warehouse_customer_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button
          mat-raised-button
          color="accent"
          class="csv-btn"
          type="button"
          (click)="createExternalCSV()">
          Create Customer CSV
        </button>
      </form>
    </div>

    <div>
      <p>More CSV buttons TBA. Backend is done, just need to add the actual buttons.</p>
    </div>
  </main>
</app-menu>
